import { IconButton } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { ButtonProps } from "src/components/base/button/button";
import { SortAsc, SortDesc } from "src/components/icons";
import { ISortDirectionType } from "src/types/common";

export enum EnumSortDirection {
    PointingUp = 0,
    PointingDown = 1,
}

export interface ISortDirectionButton extends ButtonProps {
    sortDirection: ISortDirectionType;
    onClick: () => void;
}

export const SortDirectionButton = ({ sortDirection, isDisabled, onClick }: ISortDirectionButton) => {
    const { t } = useTranslation("extended-search");

    return (
        <IconButton
            onClick={onClick}
            variant="outline"
            icon={isDisabled || sortDirection === EnumSortDirection.PointingDown ? <SortDesc boxSize={3} /> : <SortAsc boxSize={3} />}
            size="md"
            colorScheme="gray"
            fill={isDisabled ? "gray.200" : "gray.800"}
            aria-label={sortDirection === EnumSortDirection.PointingUp ? t("labels.sort-ascending") : t("labels.sort-descending")}
            isDisabled={isDisabled}
        />
    );
};
